'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./node_modules/has/src/index.js
// module id = XfW5
// module chunks = 25 26 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42